import { createSlice } from "@reduxjs/toolkit";
import undoable, { groupByActionTypes } from "redux-undo";
export const initialState = {
    changes: {},
    changesValidity: {},
    parameters: {}
};
const slice = createSlice({
    initialState,
    name: "TAModelEditedReducers",
    reducers: {
        resetChanges: (state) => {
            state.changes = initialState.changes;
            state.changesValidity = initialState.changesValidity;
            state.parameters = initialState.parameters;
        },
        saveParameters: (state) => {
            const isValid = Object.values(state.changesValidity || {}).every((v) => v);
            if (isValid) {
                state.parameters = {
                    ...state.parameters,
                    ...state.changes
                };
            }
        },
        setBowFactor: (state, action) => {
            state.changes.bow = action.payload.value;
            state.changesValidity.bow = action.payload.isValid;
        },
        setCommitment: (state, action) => {
            state.changes.commitment = action.payload.value;
            state.changesValidity.commitment = action.payload.isValid;
        },
        setContributionRates: (state, action) => {
            if (action.payload.value !== undefined && action.payload.value.length > 4 && action.payload.value[4] === undefined) {
                action.payload.value[4] = action.payload.value?.filter((v) => v)?.[0];
            }
            state.changes.contributionRates = action.payload.value;
            state.changesValidity.contributionRates = action.payload.isValid;
        },
        setDescription: (state, action) => {
            state.changes.description = action.payload.value;
            state.changesValidity.description = action.payload.isValid;
        },
        setGrowthRate: (state, action) => {
            state.changes.growthRate = action.payload.value;
            state.changesValidity.growthRate = action.payload.isValid;
        },
        setLifetime: (state, action) => {
            state.changes.lifetime = action.payload.value;
            state.changesValidity.lifetime = action.payload.isValid;
        },
        setMinDistributionRate: (state, action) => {
            state.changes.minDistributionRate = action.payload.value;
            state.changesValidity.minDistributionRate = action.payload.isValid;
        },
        setModelName: (state, action) => {
            state.changes.name = action.payload.value;
            state.changesValidity.modelName = action.payload.isValid;
        }
    }
});
export const undoTaActionPrexif = "taUndoableReducers/UNDO_TA";
export const redoTaActionPrexif = "taUndoableReducers/REDO_TA";
export const clearTaActionPrefix = "taUndoableReducers/CLEAR_TA";
export const undoTaAction = (id) => ({ payload: { id }, type: `${undoTaActionPrexif}_${id || 0}` });
export const redoTaAction = (id) => ({ payload: { id }, type: `${redoTaActionPrexif}_${id || 0}` });
export const clearTaAction = (id) => ({ payload: { id }, type: `${clearTaActionPrefix}_${id || 0}` });
export const { saveParameters, setBowFactor, setCommitment, setContributionRates, setGrowthRate, setLifetime, setMinDistributionRate, setModelName, setDescription, resetChanges } = slice.actions;
const inputSetActions = [
    setBowFactor.type,
    setCommitment.type,
    setGrowthRate.type,
    setLifetime.type,
    setMinDistributionRate.type,
    setModelName.type,
    setDescription.type
];
export const taReducers = (s, a) => {
    const state = s ?? { model: {}, undoRedoId: "" };
    const id = a?.payload?.id;
    const undo = undoTaAction(id).type;
    const redo = redoTaAction(id).type;
    const clear = clearTaAction(id).type;
    const actions = Object.values(slice.actions).map((ac) => ac.type.toString())
        .concat([undo, redo, clear]);
    if ((id || id === "") && actions.includes(a.type)) {
        const reducer = undoable(slice.reducer, {
            clearHistoryType: clear,
            groupBy: groupByActionTypes(inputSetActions),
            redoType: redo,
            undoType: undo
        });
        return {
            model: {
                ...state.model,
                [id]: reducer(id in state.model ? state.model[id] : { future: [], past: [], present: initialState }, a)
            },
            undoRedoId: state.undoRedoId
        };
    }
    return state;
};
